export const SET_ENTITIES = 'SET_ENTITIES';
export const SET_IS_FETCHING_ENTITIES = 'SET_IS_FETCHING_ENTITIES';
